import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { TextFieldProps } from '@mui/material';
import styles from './GlobalTextField.module.scss';

interface CustomPhoneInputProps {
    country: string;
    inputStyle?: React.CSSProperties;
    onBlur?: (field: string) => void;
    value: string;
    onChange: (value: string) => void;
    error?: boolean;
    helperText?: string | false;
    disabled?: boolean
}

const GlobalPhoneInput: React.FC<CustomPhoneInputProps> = ({
    country,
    inputStyle,
    onBlur,
    value,
    onChange,
    error,
    helperText,
    disabled
}) => {

    return (
        <>
            <PhoneInput
                country={country}
                inputStyle={{
                    borderColor: error ? "#FF0000" : "#D9DBDC",
                    backgroundColor: "#F7FAFC",
                    height: "40px",
                    width: "100%",
                }}
                onBlur={() => onBlur && onBlur("contact")}
                value={value}
                onChange={onChange}
                disabled={disabled}
            />
            {
                error && helperText && (
                    <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                        {helperText}
                    </div>
                )
            }
        </>
    );
};

export default GlobalPhoneInput;
